module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero13.png?39edd689";